import { gql } from '@apollo/client';

export default gql`
  query preloadUrlQuery($id: ID!, $kind: UploadKind!) {
    preUpload(kind: $kind, id: $id) {
      url
      objectKey
    }
  }
`;
